import { AppContext } from 'contexts/AppContext'
import React, { useContext } from 'react'
import { createUseStyles } from 'react-jss'

const jss = createUseStyles({
    roundIconButton1: {
        backgroundColor: (styleGuide) => styleGuide.color16,
        color: (styleGuide) => styleGuide.color1,
        borderRadius: '50%',
        height: (styleGuide) => styleGuide.roundButtonSize,
        width: (styleGuide) => styleGuide.roundButtonSize,
        fontWeight: '600',
        border: 'none',
        padding: '9px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        
        '&:hover':{
            backgroundColor: (styleGuide) => styleGuide.color17,
        },
        
        '&:disabled':{
            backgroundColor: (styleGuide) => styleGuide.color16,
            opacity: 0.7,
            cursor: 'not-allowed'
        }
    }
})

const RoundIconButton1 = (props) => {
    const { styleGuide } = useContext(AppContext)
    const classes = jss(styleGuide)
    
    return (
        <button
            onClick={props.onClick}
            style={{...props.style}}
            disabled={props.disabled}
            className={`${classes.roundIconButton1} ${props.className}`}
        > 
            {props.icon}
        </button>
    )
}

export default RoundIconButton1;